<template>
  <card-seplag titulo="Escala Anual de Licença Prêmio">
    <Panel header="Ação" class="p-col-12" style="margin-top: 10px">
      <div class="p-grid p-col-12 p-align-center p-justify-center">
        <!-- botões: Imprimir Escala | Gerar Processo | Fechar Escala -->
        <div class="p-md-3 p-col-12">
          <Button
            label="Gerar Processo"
            icon="pi pi-cog"
            class="p-button-secondary botao-acao"
            @click="showModalGerarProcesso()"
            :disabled="!habilitaAgendamento"
          />
        </div>
        <div class="p-md-3 p-col-12">
          <Button
            label="Exportar Excel"
            icon="pi pi-file-excel"
            class="p-button-info"
            @click="gerarCsv()"
          />          
        </div>
      </div>
      <div
        class="p-grid p-align-center p-justify-center"
        v-if="fecharEscala && habilitaAgendamento"
      >
        <Rotulo cols="12 2" nome="Número D.O">
          <InputText type="text" v-model="escala.numrDo" />
        </Rotulo>
        <Rotulo cols="12 2" nome="Página">
          <InputText type="text" v-model="escala.numrPaginaDo" />
        </Rotulo>
        <Rotulo cols="12 2" nome="Data Publicação">
          <InputMask
            mask="99/99/9999"
            placeholder="dd/mm/aaaa"
            v-model="escala.dataPublicacaoDo"
          />
        </Rotulo>
        <div class="p-col-12"></div>
        <div class="p-md-3 p-col-12">
          <Button
            label="Salvar"
            icon="pi pi-check"
            class="p-button-success botao-acao"
            @click="encerrarEscala()"
            :disabled="!habilitaAgendamento"
          />
        </div>
        <div class="p-md-3 p-col-12">
          <Button
            label="Fechar"
            icon="pi pi-trash"
            class="p-button-danger botao-acao"
            @click="fecharEscala = !fecharEscala"
            :disabled="!habilitaAgendamento"
          />
        </div>
      </div>
    </Panel>
    <Panel :header="'Filtro'" class="p-col-12">
      <div class="p-grid p-align-center p-justify-center">
        <Rotulo cols="12 2" nome="Data">
          <InputMask
            mask="99/99/9999"
            placeholder="dd/mm/aaaa"
            v-model="dadosBusca.dataBusca"
          />
        </Rotulo>
        <Rotulo cols="12 2" nome="Mês">
          <Dropdown
            v-model="dadosBusca.mes"
            :options="listaMeses"
            optionLabel="name"
            optionValue="value"
            placeholder="Selecione..."
            showClear
          />
        </Rotulo>
        <Rotulo cols="12 2" nome="Busca Nome/matrícula/setor">
          <InputText
            type="text"
            v-model="dadosBusca.filtro"
            v-on:keyup.enter="buscaServidor()"
          />
        </Rotulo>
        <div class="p-md-2 p-col-12">
          <label style="padding: 10px"> </label>
          <Button
            label="Buscar"
            icon="pi pi-search"
            class="p-button-info"
            @click="buscaServidor()"
          />
        </div>
      </div>
    </Panel>

    <div class="p-col-12" v-if="dadosTabela.length > 0">
      <table-seplag
        :dados="dadosTabela"
        :exibirCabecalho="false"
        :campos="[]"
        :paginacao="true"
        :onSearchPaginacao="carregarDadosAgendamento"
        :totalRegistro="totalRecords"
      >
        <Column field="idReg" header="ID">
          <template #body="slotProps">
            <p>{{ slotProps.data.idReg }}</p>
          </template>
        </Column>
        <Column field="matricula" header="Matrícula">
          <template #body="slotProps">
            <p>{{ slotProps.data.matricula }}</p>
          </template>
        </Column>
        <Column
          field="nome"
          header="Nome Servidor"
          :bodyStyle="{ width: '40%' }"
        >
          <template #body="slotProps">
            <p>
              {{ slotProps.data.nome }}<br /><span
                style="font-size: 11px; font-weight: 700"
                >{{ slotProps.data.setor }}</span
              >
            </p>
          </template>
        </Column>
        <Column
          field="dataInicioDireitoAfastamento"
          header="Periodo Aquisitivo"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicioPeraq }}<br />{{
                slotProps.data.dataFimPeraq
              }}</span
            >
          </template>
        </Column>
        <Column
          field="dataInicio"
          header="Periodo de Usufruto"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicio }}<br />{{
                slotProps.data.dataFim
              }}</span
            >
          </template>
        </Column>
        <Column
          field="totalDias"
          header="Dias Solicitados"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <div
              style="
                display: flex;
                text-align: center;
                flex-direction: column;
                align-items: center;
              "
            >
              <span>
                {{
                  slotProps.data && slotProps.data.periodoJornadaReduzida
                    ? slotProps.data.totalDias * 2
                    : slotProps.data.totalDias
                }}
                <br />
                <strong>{{
                  slotProps.data && slotProps.data.periodoJornadaReduzida
                    ? "(Jornada Reduzida)"
                    : ""
                }}</strong
                ><br />
                <strong>{{
                  slotProps.data && slotProps.data.periodoJornadaReduzida
                    ? slotProps.data.periodoJornadaReduzida
                    : ""
                }}</strong>
              </span>
            </div>
          </template>
        </Column>
        <Column
          field="origem"
          header="Origem"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.origem ? slotProps.data.origem : "SEAP" }}</span
            >
          </template>
        </Column>
      </table-seplag>
    </div>

    <cadastro-rapido
      v-if="habilitaAgendamento"
      tituloTela="Gerar Processo"
      tamanhoTela="40.vw"
      v-model="exibirTelaGerarProcesso"
      :modoEdicao="'adicionar'"
      :onAdicionar="gerarProcessoSigadoc"
      textoButton="Gerar"
      optionValue="code"
    >
      <Rotulo nome="Login cadastrante do Sigadoc" cols="12 6">
        <InputText type="text" v-model="registroProcesso.usuarioSigadoc" />
      </Rotulo>
      <Rotulo nome="Login Subscritor do Sigadoc" cols="12 6">
        <InputText type="text" v-model="registroProcesso.subscritorSigadoc" />
      </Rotulo>
      <Rotulo
        nome="Artigo (O ou A) + Cargo do Gestor do Órgão/Entidade"
        cols="12"
      >
        <InputText type="text" v-model="registroProcesso.cargoMaximo" />
      </Rotulo>
      <Rotulo nome="Exercício" cols="12 6">
        <InputText type="number" v-model="registroProcesso.anoEscala" />
      </Rotulo>
      <Rotulo nome="Sigla do Orgao" cols="12 6">
        <InputText type="text" v-model="registroProcesso.siglaOrgao" />
      </Rotulo>
    </cadastro-rapido>
    <div class="p-md-3 p-col-12">
      <Button
        label="Voltar"
        icon="pi pi-arrow-left"
        @click="voltarPagina()"
        class="p-button-secondary"
      />
    </div>
  </card-seplag>
</template>

<script>
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import Column from "primevue/column";
import Rotulo from "@/template/RotuloSeplag.vue";
import exportFromJSON from "export-from-json";
import { baseApiUrl } from "@/config/global";
import { simNao } from "@/config/global";
import moment from "moment";
const getDefaulValida = () => {
  return {
    direitoAfastamento: {
      idenDireitoAfastamento: null,
    },
    descJustificativa: "",
    numrMatriculaChefe: null,
    numrVinculoChefe: null,
    statusProgramacao: {
      idenStatusProgramacao: { name: "Sim", code: "S" },
    },
  };
};
const getDefaulGerarProcesso = () => {
  return {
    tipoAfastamento: "licencapremio",
    matricula: null,
    vinculo: null,
    idenPessoa: null,
    usuarioSigadoc: null,
    subscritorSigadoc: null,
    cargoMaximo: null,
    anoEscala: null,
    siglaOrgao: null,
    idenEscalaAfastamento: null,
  };
};
export default {
  name: "escalaAnualLicencaPremioRh",
  components: { CardSeplag, Column, Rotulo, CadastroRapido, TableSeplag },
  data() {
    return {
      apiUrlRecurso: "",
      tituloTabela: "",
      dadosAgendamentosPorSetor: [],
      dadosTabela: [],
      mostrarJson: [],
      expandedRows: null,
      layout: "list",

      registro: getDefaulValida(),
      dadosAprovacao: [],
      simNao: simNao,
      exibirTelaValidacaoPendente: false,

      exibirTelaNovaFerias: false,
      selectedTipoGozo: null,
      dadosFerias: null,
      tiposGozo: [],
      data_inicio: null,
      data_fim: null,

      max_date: null,
      min_date: moment().format(),
      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      datePikermasks: {
        input: "DD/MM/YYYY",
      },

      fecharEscala: false,

      dadosBusca: {
        matricula: null,
        numeroVinculo: null,
        dataBusca: null,
        mes: null,
        filtro: null,
      },
      buscaAtiva: false,
      msgErroBusca: [
        {
          msg: "Não foi encontrado nenhum servidor nessa busca",
        },
      ],

      registroProcesso: getDefaulGerarProcesso(),
      exibirTelaGerarProcesso: false,
      habilitaAgendamento: true,
      escala: null,
      totalRecords: 0,

      listaMeses: [
        { name: "Janeiro", value: "1" },
        { name: "Fevereiro", value: "2" },
        { name: "Março", value: "3" },
        { name: "Abril", value: "4" },
        { name: "Maio", value: "5" },
        { name: "Junho", value: "6" },
        { name: "Julho", value: "7" },
        { name: "Agosto", value: "8" },
        { name: "Setembro", value: "9" },
        { name: "Outubro", value: "10" },
        { name: "Novembro", value: "11" },
        { name: "Dezembro", value: "12" },
      ],
    };
  },
  methods: {
    async carregarDados() {
      this.dadosBusca.matricula = await this.$store.getters.getMatricula;
      this.dadosBusca.numeroVinculo = await this.$store.getters.getVinculo;
      this.idenPessoa = await this.$store.getters.getIdenPessoa;
      this.escalaAnualRhSelecionada = this.$store.getters
        .getEscalaAnualRhSelecionada
        ? this.$store.getters.getEscalaAnualRhSelecionada.idenEscalaAfastamento
        : null;

      this.habilitaAgendamento =
        this.$store.getters.getEscalaAnualRhSelecionada &&
        this.$store.getters.getEscalaAnualRhSelecionada.situacao == "ENCERRADO"
          ? false
          : true;
      if (!this.escalaAnualRhSelecionada) {
        this.$router.push({ name: "cadEscala" });
      }

      /*
        Carrega dados de acordo com o status selecionado
      */
      var urlSetores = "";
      this.apiUrlRecurso = "lincencaview";

      this.dadosTabela = [];
      urlSetores = this.$http.put(
        `${baseApiUrl}/${this.apiUrlRecurso}/rh/escala/lista/${this.escalaAnualRhSelecionada}?size=10&page=0`,
        JSON.stringify(this.dadosBusca)
      );

      let v_setores = await urlSetores;
      if (v_setores.status == 200) {
        this.dadosTabela = v_setores.data.content;
        this.totalRecords = v_setores.data.totalElements;
      }
    },
    async carregarDadosAgendamento(size = 10, page = 0) {
      var urlSetores = "";
      this.apiUrlRecurso = "lincencaview";
      urlSetores = this.$http.put(
        `${baseApiUrl}/${this.apiUrlRecurso}/rh/escala/lista/${this.escalaAnualRhSelecionada}?size=${size}&page=${page}`,
        JSON.stringify(this.dadosBusca)
      );

      let v_setores = await urlSetores;

      if (v_setores.status == 200) {
        this.dadosTabela = v_setores.data.content;
        this.totalRecords = v_setores.data.totalElements;
      }
    },
    exportar(lista){
      const fileName = 'EscalaLicenca';
      const exportType = exportFromJSON.types.csv;

      exportFromJSON({ data: lista, fileName, exportType, delimiter: ';' });

    },
    async gerarCsv() {      
        this.apiUrlRecurso = "lincencaview";
        await this.$http.post(
          `${baseApiUrl}/${this.apiUrlRecurso}/rh/escala/listacsv/${this.escalaAnualRhSelecionada}`,
          JSON.stringify(this.dadosBusca)
        ).then(response =>{
          const listaDTO = response.data.map(
            ({ nome, matricula, dataInicioPeraq, dataFimPeraq, dataInicio, dataFim, periodoJornadaReduzida, setorPend, setor }) => ({
              "Matricula":matricula,
              "Nome":nome,
              "Seap": setorPend,
              "Setor": setor,
              "Inicio Periodo Aquisitivo": dataInicioPeraq,
              "Fim Periodo Aquisitivo": dataFimPeraq,
              "Inicio Usufruto": dataInicio,
              "Fim Usufruto": dataFim,
              "Total Dias": periodoJornadaReduzida
              ? `${(moment(dataFim, "DD/MM/YYYY").diff(moment(dataInicio, "DD/MM/YYYY"), "days") + 1) * 2} ${periodoJornadaReduzida}`
              : `${moment(dataFim, "DD/MM/YYYY").diff(moment(dataInicio, "DD/MM/YYYY"), "days") + 1}`
            })
          );



          this.exportar(listaDTO)
        });
    },
    gerarProcessoSigadoc() {
      this.registroProcesso.matricula = this.$store.getters.getMatricula;
      this.registroProcesso.vinculo = this.$store.getters.getVinculo;
      this.registroProcesso.idenPessoa = this.$store.getters.getIdenPessoa;
      this.registroProcesso.idenEscalaAfastamento =
        this.escalaAnualRhSelecionada;

      this.$http
        .put(
          `${baseApiUrl}/lincencaview/rh/escala/gerarprocessosigadoc`,
          JSON.stringify(this.registroProcesso)
        )
        .then((res) => {
          //console.log(res)
          this.limparDados();
          this.$toast.add({
            severity: "success",
            summary: "Criado a PORTARIA com Sucesso",
            detail: "Protocolo: " + res.data,
            life: 3000,
          });
        });
    },
    showModalGerarProcesso() {
      this.registroProcesso = getDefaulGerarProcesso();
      this.exibirTelaGerarProcesso = true;
    },
    limparDados() {
      this.registroProcesso = getDefaulGerarProcesso();
      this.exibirTelaGerarProcesso = false;
    },
    buscaServidor() {
      this.$toast.removeAllGroups();
      this.dadosBusca.parametroPesquisa = this.dadosBusca.filtro
        ? this.dadosBusca.filtro.trim()
        : null;
      this.dadosBusca.dataBusca =
        this.dadosBusca.dataBusca != "" ? this.dadosBusca.dataBusca : null;
      this.$http
        .put(
          `${baseApiUrl}/${this.apiUrlRecurso}/rh/escala/lista/${this.escalaAnualRhSelecionada}?size=10&page=0`,
          JSON.stringify(this.dadosBusca)
        )
        .then((res) => {
          this.dadosTabela = res.data.content;
          this.totalRecords = res.data.totalElements;
        });
    },
    voltarPagina() {
      this.$router.push({ name: "cadEscala" });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>
